import { withPopup } from '../Utils';
import ActionsStep from './ActionsStep';

export default withPopup(ActionsStep);
